import getApi from '../../api'
import { MailAttachement } from '../../model/Mail'

export const getMailAttachment = (messageId: string, partId: number, cdaFileId?: string) =>
  getApi().get<MailAttachement>(
    `/mss/messages/${messageId}/attachment/${partId}${cdaFileId ? `/${cdaFileId}` : ''}`,
  )
